import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

/**
 * AreaSelect component provides a dropdown select element for choosing areas.
 * It fetches the area list from Redux store and renders them as options.
 *
 * @component
 * @param {Object} props
 * @param {function} props.onChange - Callback function triggered when selection changes
 * @param {string} [props.emptyString] - Optional text to display as the first empty option
 * @param {string} props.value - Currently selected area ID
 * @returns {React.ReactElement} A select element with area options
 */
const AreaSelect = ({ onChange, emptyString = '', value }) => {
    const areaList = useSelector((state) => state.common.areaList);

    const selectStyles = {
        padding: '0.5em 1em',
        borderRadius: '4px',
        border: '1px solid #dbdbdb',
        background: '#fff',
        color: '#363636',
        outline: 'none',
        minWidth: '120px'
    };

    return (
        <select style={selectStyles} value={value} onChange={e => onChange(e.target.value)}>
            <option value="">{emptyString}</option>
            {areaList?.map((area) => (
                <option key={area._id} value={area._id}>
                    {area.name}
                </option>
            ))}
        </select>
    );
};

AreaSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    emptyString: PropTypes.string,
    value: PropTypes.string,
};

export default AreaSelect;
